<template>
  <vuex-table
    :fields="fields"
    class="table-overflow-visible"
    table_store="autocaller_v2/campaigns/tasks/table"
  >
    <template slot="name" slot-scope="{ item }">
      {{ item.name }}
    </template>
    <template slot="state" slot-scope="{ item }">
      <state-badge :value="item.state" />
    </template>

    <template v-if="item.state == 'pending'" slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit_item(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>
        <span
          v-if="!item.active"
          class="dropdown-item-icon dropdown-item-icon--trash"
          @click="remove(item)"
        >
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import StateBadge from './task-badge-state';
  import { TaskModalService } from '@autocaller_v2/modals/TaskModalService';
  import { TaskService } from '@autocaller_v2/services/TaskService';
  import { mapActions, mapMutations } from 'vuex';
  export default {
    components: {
      StateBadge
    },
    props: {
      use_skills_in_campaign: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      fields() {
        return [
          {
            key: 'id',
            label: this.$t('autocaller_v2.task.field.id'),
            sortable: true
          },
          {
            key: 'number',
            label: this.$t('autocaller_v2.task.field.number'),
            sortable: false,
            formatter: (value) => (Array.isArray(value) ? value.join(', ') : value)
          },
          {
            key: 'caller_id',
            label: this.$t('autocaller_v2.task.field.caller_id'),
            sortable: false,
            thStyle: { width: '240px' }
          },
          {
            key: 'state',
            label: this.$t('autocaller_v2.task.field.status'),
            sortable: false
          },
          {
            key: 'priority',
            label: this.$t('autocaller_v2.task.field.priority'),
            sortable: false
          },
          {
            key: 'attempts',
            label: this.$t('autocaller_v2.task.field.attempts'),
            sortable: false
          },
          {
            key: 'last_attempt',
            label: this.$t('autocaller_v2.task.field.last_attempt'),
            sortable: true
          },
          {
            key: 'next_attempt',
            label: this.$t('autocaller_v2.task.field.next_attempt'),
            sortable: true
          },
          {
            key: 'created_at',
            label: this.$t('autocaller_v2.task.field.lead_date'),
            sortable: true,
            thStyle: { width: '150px' }
          },
          {
            key: 'lead_date',
            label: this.$t('autocaller_v2.task.field.created_at'),
            sortable: true,
            thStyle: { width: '150px' }
          },
          {
            key: 'delayed_until',
            label: this.$t('autocaller_v2.task.field.delayed_until'),
            thStyle: { width: '150px' },
            sortable: false
          },
          {
            key: 'client_data',
            label: this.$t('autocaller_v2.task.field.additionally'),
            thStyle: { width: '100px' },
            sortable: false
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '120px' }
          }
        ];
      }
    },
    created() {
      const id = this.$route.params.id;
      this.set_campaign_id(id);
    },
    methods: {
      ...mapMutations({
        set_campaign_id: 'autocaller_v2/campaigns/tasks/campaign_id'
      }),
      ...mapActions('autocaller_v2/campaigns/tasks/table', ['getAsyncData']),
      remove(item) {
        item.task_id = item.id;
        item.campaign_id = this.$route.params.id;
        TaskModalService.remove(item).on('success', () => this.getAsyncData());
      },
      edit(item, payload) {
        item.campaign_id = this.$route.params.id;
        TaskService.editItem(item.campaign_id, item.id, payload)
      },
      edit_item(item) {
        TaskModalService.edit(item, this.use_skills_in_campaign, ).on('success', () => this.getAsyncData());
      }
    }
  };
</script>

<style lang="scss">
  .table-overflow-visible {
    .table-fw {
      .vti__dropdown-list {
        min-height: 150px;
      }
    }
  }
</style>
